import { render, staticRenderFns } from "./Ownerships.vue?vue&type=template&id=0064f102&scoped=true&"
import script from "./Ownerships.vue?vue&type=script&lang=js&"
export * from "./Ownerships.vue?vue&type=script&lang=js&"
import style0 from "./Ownerships.vue?vue&type=style&index=0&id=0064f102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064f102",
  null
  
)

export default component.exports